import React, { useState } from 'react'
import { useDispatch } from 'react-redux'
import { useSelector } from 'react-redux'
import { Link } from 'react-router-dom'
import { delTopics, updateTopicName } from '../../helpers/temas'
import { useForm } from '../../hooks/ useForm'
import { refreshthemes } from '../../reducer/AsignaturasReducer'
import { deleteThemes, refreshTemas } from '../../reducer/TemasReducer'
import Loading from '../tools/Loading'

const TemaRow = ({number, idAsig, idTema, nombreTema, date, numThems}) => {
    const dispatch = useDispatch();
    const {email} = useSelector(state => state.perfil);
    const [loading, setLoading] = useState(false)
    const [value, handleInputChange] = useForm({nameTema: nombreTema});
    const [edit, setEdit] = useState(false)
    const {nameTema} = value;

    const handleUpdateName = () => {
        setLoading(true)
        updateTopicName(email,idAsig,idTema,nameTema)
        .then(() => {
            dispatch(refreshTemas(idTema,nameTema))
            setLoading(false)
            setEdit(false)
        })
        .catch(e => console.log(e))
    }

    const handleDelete = () => {
        delTopics(email,idAsig,idTema).then(()=> {
            dispatch(deleteThemes(idTema));
            dispatch(refreshthemes(idAsig,numThems-1))
        })  
    }

    return (
        <tr>
            <td className='td_1'>{number}</td>
            <td className='td_2'>
                {
                    edit
                    ?   <input className='input_tema_up' value={nameTema} onChange={handleInputChange} name='nameTema' type='text' />
                    :<Link to={`/asignatura/${idAsig}/${idTema}`}>{nombreTema}</Link>
                }
            </td >
            <td className='td_3'>
            {
                edit
                ? 
                    loading
                        ? <Loading />
                        :
                            <>
                                <i className='fas fa-save' onClick={handleUpdateName}></i>
                                <i onClick={() => setEdit(!edit)} className='fas fa-window-close'></i> 
                            </>
                :<i onClick={() => setEdit(!edit)} className='fas fa-edit'></i> 
            }
            </td>
            
            <td className='td_4'>
                <i className='fas fa-trash' onClick={() => handleDelete()}></i>
            </td>
        </tr>
    )
}

export default TemaRow
